<template>
    <div>
        <div v-if="leadSinAsignar">
            <v-card color="grey lighten-4" flat tile style="margin-top: 20px">
                <v-toolbar>
                    <v-toolbar-title>
                        <h3>
                            Certificado:
                            {{
                                this.poliza.poliza != "null"
                                    ? "#" + this.poliza.poliza
                                    : "Aun sin certificado"
                            }}
                        </h3>
                    </v-toolbar-title>

                    <v-spacer></v-spacer>
                    <h3>Plan: {{ nombreProducto }}</h3>
                    <v-spacer></v-spacer>

                    <v-spacer></v-spacer>
                    <h3>Mensualidad: {{ toCurrency(poliza.montoPrimerPago) }}</h3>
                    <v-spacer></v-spacer>

                    <v-btn v-if="canEdit" icon @click="verEmisionEditable()">
                        <v-icon>mdi-pencil</v-icon>
                    </v-btn>

                    <v-btn @click="goBack()" style="background-color: #ff0042; color: white;">
                        Regresar
                    </v-btn>
                </v-toolbar>

            </v-card>
            <v-divider></v-divider>
            <AccionesEmision :poliza="poliza" :producto="currentProducto" :beneficiarios="beneficiarios"
                :lead="infoLead" :motivosCancelacion="motivosCancelacionFiltrados" :porcentaje="porcentaje"
                @reactivarPoliza="handleReactivarPoliza" @obtenerCertificado="handleObtenerCertificado"
                @obtenerCertificadoWs="handleCotizarWs" @regenerarCuotas="handleRegenerarCuotas"
                @emitirSinCodigo="handleEmitirSinCodigo" @reenviarCertificado="handleReenviarCertificado"
                @cancelarEmision="handleCancelarEmision" @aplicarEndoso="handleAplicarEndoso"
                @renovacionManual="handleRenovacionManual" />
            <v-row>
                <v-col cols="7">
                    <v-form>
                        <v-row>
                            <v-col>
                                <v-stepper non-linear>
                                    <v-stepper-header class="d-flex justify-space-around">
                                        <v-stepper-step step="1" editable>
                                            Cotizacion / Poliza
                                        </v-stepper-step>

                                        <v-stepper-step step="2" editable>
                                            Datos del cliente
                                        </v-stepper-step>
                                        <v-stepper-step step="3" editable v-if="hasEndoso">
                                            Detalles de endosos
                                        </v-stepper-step>
                                    </v-stepper-header>

                                    <v-stepper-items>
                                        <v-stepper-content step="1">

                                            <v-row style="padding: 20px; margin-top: -35px">
                                                <v-col :cols="4">
                                                    <v-text-field label="Póliza aseguradora"
                                                        v-model="poliza.polizaAseguradora" readonly>
                                                    </v-text-field>
                                                </v-col>

                                            </v-row>
                                            <v-row style="padding: 20px; margin-top: -35px">
                                                <v-col :cols="tipoContratanteVisible ? 3 : 4">
                                                    <v-text-field label="Cliente" v-model="poliza.newCliente" readonly>
                                                    </v-text-field>
                                                </v-col>

                                                <v-col :cols="tipoContratanteVisible ? 3 : 4">
                                                    <v-autocomplete label="Plan" v-model="poliza.productos"
                                                        :items="currentProducto ? [currentProducto] : []"
                                                        item-text="nombre" item-value="id" placeholder="Requerido"
                                                        readonly :rules="[$rules.required]">
                                                    </v-autocomplete>
                                                </v-col>

                                                <v-col :cols="tipoContratanteVisible ? 3 : 4">
                                                    <v-text-field label="Fecha de Emisión" prepend-icon="mdi-calendar"
                                                        v-model="poliza.emisionDate" readonly></v-text-field>
                                                </v-col>

                                                <v-col cols="3" v-if="tipoContratanteVisible">
                                                    <v-select label="Tipo de contratante"
                                                        v-model="poliza.tipo_contratante" :items="tipos_contratante"
                                                        readonly item-text="text" item-value="value">
                                                    </v-select>
                                                </v-col>

                                                <v-col cols="4">
                                                    <v-text-field label="Estatus de la Póliza" v-model="poliza.status"
                                                        readonly></v-text-field>
                                                </v-col>

                                                <v-col cols="4" v-if="poliza.status == 'Cancelada'">
                                                    <v-text-field label="Fecha de Cancelación"
                                                        prepend-icon="mdi-calendar" v-model="poliza.canceladaDate"
                                                        readonly></v-text-field>
                                                </v-col>

                                                <v-col cols="4" v-if="
                                                    poliza.status == 'Finalizada' ||
                                                    poliza.status == 'Cancelada'
                                                ">
                                                    <v-select label="Motivo de Cancelación / Finalización"
                                                        v-model="poliza.canceladaFinalizadaMotivo"
                                                        :items="motivosCancelacionFiltrados" readonly
                                                        item-text="motivoCancelacion"
                                                        item-value="motivoCancelacion"></v-select>
                                                </v-col>

                                                <v-col :cols="isPagadaTotalOrRenovada ? 3 : 4">
                                                    <v-text-field label="Inicio de Vigencia" v-model="poliza.inicioDate"
                                                        prepend-icon="mdi-calendar" readonly></v-text-field>
                                                </v-col>

                                                <v-col :cols="isPagadaTotalOrRenovada ? 3 : 4">
                                                    <v-text-field label="Fin de Vigencia" v-model="poliza.finDate"
                                                        prepend-icon="mdi-calendar" readonly></v-text-field>
                                                </v-col>

                                                <v-col cols="3" v-if="isPagadaTotalOrRenovada">
                                                    <v-text-field label="Póliza renovada por" v-model="poliza.anterior"
                                                        readonly></v-text-field>
                                                </v-col>

                                                <v-col :cols="isPagadaTotalOrRenovada ? 3 : 4">
                                                    <v-text-field label="Pago mensual" v-model="poliza.montoSubsecuente"
                                                        readonly prefix="$"></v-text-field>
                                                </v-col>

                                                <v-col cols="4" v-if="visible">
                                                    <v-text-field label="No. Cotización / Lead ID"
                                                        v-model="poliza.leadId" readonly></v-text-field>
                                                </v-col>

                                                <v-col cols="6" v-if="
                                                    poliza.polizaSustituida &&
                                                    poliza.status == 'Cancelada'
                                                ">
                                                    <v-text-field label="Póliza de sustitución"
                                                        v-model="poliza.polizaSustituida" readonly append-icon="mdi-eye"
                                                        @click:append="
                                                            $router.push({
                                                                name: 'emision',
                                                                params: { uuid: poliza.polizaSustituida },
                                                            })
                                                            "></v-text-field>
                                                </v-col>

                                                <v-col cols="4" v-if="poliza.status == 'Finalizada'">
                                                    <v-text-field label="Fecha de Finalización"
                                                        v-model="poliza.finalizadaDate" prepend-icon="mdi-calendar"
                                                        readonly></v-text-field>
                                                </v-col>

                                                <v-col cols="4" v-if="visible">
                                                    <v-text-field label="Periodicidad de pago"
                                                        v-model="poliza.periodicidad" readonly>
                                                    </v-text-field>
                                                </v-col>
                                                <v-col cols="4" v-if="visible">
                                                    <v-text-field label="Periodicidad de pago"
                                                        v-model="poliza.periodicidad" readonly>
                                                    </v-text-field>
                                                </v-col>
                                                <v-col cols="4" v-if="visible">
                                                    <v-text-field label="Años" v-model="years" readonly></v-text-field>
                                                </v-col>

                                                <v-col cols="4" v-if="visible">
                                                    <v-text-field label="Número de cuotas" v-model="poliza.numeroCuotas"
                                                        readonly></v-text-field>
                                                </v-col>
                                                <v-col cols="4" v-if="visible">
                                                    <v-text-field label="Forma de Pago" v-model="poliza.formaPago"
                                                        readonly></v-text-field>
                                                </v-col>
                                                <v-col cols="4">
                                                    <v-text-field label="Fecha de primer pago"
                                                        v-model="poliza.fechaPrimerPago" prepend-icon="mdi-calendar"
                                                        readonly></v-text-field>
                                                </v-col>

                                                <v-col cols="4" v-if="esAsistencias && esRenovada">
                                                    <v-text-field label="Fecha de renovación"
                                                        v-model="poliza.renovadaDate" prepend-icon="mdi-calendar"
                                                        readonly></v-text-field>
                                                </v-col>

                                                <v-col cols="4" v-if="esAsistencias && esRenovada">
                                                    <v-text-field label="Numero de Renovaciones"
                                                        v-model="poliza.renovadaNum" readonly>
                                                    </v-text-field>
                                                </v-col>

                                                <v-col cols="4" v-if="esAsistencias">
                                                    <v-text-field label="Mes de membresia" v-model="poliza.mesMembresia"
                                                        readonly>
                                                    </v-text-field>
                                                </v-col>

                                                <v-col cols="4" v-if="esAsistencias && emision.fechaReactivacion">
                                                    <v-text-field label="Fecha de reactivación"
                                                        v-model="poliza.reactivadaDate" prepend-icon="mdi-calendar"
                                                        readonly></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row dense v-if="showResponse && isAdmin">
                                                <v-col cols="12" md="8" lg="6">
                                                    <div>
                                                        <p> Respuesta de aseguradora </p>
                                                        <span class="text-red"> {{ this.emision.response }}</span>
                                                    </div>
                                                </v-col>
                                            </v-row>
                                            <v-row v-if="emision && emision.ramo == 'ASISTENCIAS'" dense justify="end">
                                                <v-col cols="12" md="8" lg="6">
                                                    <agregarTelefonoButton :tarjeta="emision.tarjeta"
                                                        :telefono="emision.telefonoContacto" :emisionId="emision.id">
                                                    </agregarTelefonoButton>
                                                </v-col>
                                            </v-row>
                                        </v-stepper-content>

                                        <v-stepper-content step="2">
                                            <v-row style="padding: 20px; margin-top: -35px">
                                                <v-col cols="4">
                                                    <v-select label="Tipo de cliente" v-model="poliza.tipo_cliente"
                                                        readonly :items="tipos_cliente"
                                                        :rules="[$rules.required]"></v-select>
                                                </v-col>
                                                <v-col cols="4">
                                                    <v-text-field label="Tipo de Persona (Régimen)"
                                                        v-model="poliza.regimen" readonly>
                                                    </v-text-field>
                                                </v-col>
                                                <v-col cols="4" v-if="poliza.regimen == 'Moral'">
                                                    <v-text-field label="Razón Social" v-model="poliza.razonSocial"
                                                        readonly></v-text-field>
                                                </v-col>
                                                <v-col cols="4" v-if="poliza.regimen != 'Moral'">
                                                    <v-text-field label="Nombre(s)" v-model="poliza.nombres"
                                                        readonly></v-text-field>
                                                </v-col>
                                                <v-col cols="4" v-if="poliza.regimen != 'Moral'">
                                                    <v-text-field label="Apellido Paterno"
                                                        v-model="poliza.apellidoPaterno" readonly></v-text-field>
                                                </v-col>
                                                <v-col cols="4" v-if="poliza.regimen != 'Moral'">
                                                    <v-text-field label="Apellido Materno"
                                                        v-model="poliza.apellidoMaterno" readonly></v-text-field>
                                                </v-col>
                                                <v-col cols="4" v-if="
                                                    poliza.regimen != 'Moral' && poliza.regimen != null
                                                ">
                                                    <v-select label="Estado Civil"
                                                        :items="['Soltero(a)', 'Casado(a)', 'Unión Libre']" readonly
                                                        v-model="poliza.statusCivil"
                                                        :rules="[$rules.required]"></v-select>
                                                </v-col>
                                                <v-col cols="4" v-if="poliza.regimen != 'Moral'">
                                                    <v-text-field label="Fecha de Nacimiento"
                                                        v-model="poliza.fechaNacimiento" readonly>
                                                    </v-text-field>
                                                </v-col>
                                                <v-col cols="4">
                                                    <v-text-field v-model="poliza.edad" label="EDAD"
                                                        placeholder="Requerido" :disabled="true" readonly>
                                                    </v-text-field>
                                                </v-col>

                                                <v-col cols="4">
                                                    <v-text-field label="RFC" v-model="poliza.rfc"
                                                        readonly></v-text-field>
                                                </v-col>
                                                <v-col cols="4" v-if="poliza.regimen != 'Moral'">
                                                    <v-text-field label="Género" v-model="poliza.selectedGenero"
                                                        readonly></v-text-field>
                                                </v-col>
                                                <v-col cols="4">
                                                    <v-text-field label="Teléfono" v-model="poliza.celular"
                                                        readonly></v-text-field>
                                                </v-col>

                                                <v-col cols="4">
                                                    <v-text-field label="Correo Electrónico"
                                                        v-model="poliza.correoElectronico" readonly>
                                                    </v-text-field>
                                                </v-col>
                                                <v-col cols="4">
                                                    <v-text-field label="Reactivacion"
                                                        v-model="poliza.reactivacion" readonly>
                                                    </v-text-field>
                                                </v-col>
                                                <v-col v-if="poliza.regimen == 'Física'" cols="4">
                                                    <v-select v-model="poliza.facturar" label="¿Desea facturar?"
                                                        :items="facturacionItems" readonly></v-select>
                                                </v-col>
                                                <v-col v-if="poliza.facturar && poliza.regimen == 'Física'" cols="4">
                                                    <v-select v-model="poliza['regimen-fiscal']" label="Tipo de régimen"
                                                        :items="tipoRegimenItems" readonly></v-select>
                                                </v-col>
                                                <v-col v-if="poliza.facturar && poliza.regimen == 'Física'" cols="4">
                                                    <v-select v-model="poliza.cfdi" label="Concepto CFDI"
                                                        :items="conceptoCFDIItems" readonly></v-select>
                                                </v-col>
                                                <v-col cols="4" v-if="!esAsistencias">
                                                    <v-text-field label="Calle" v-model="poliza.calle" readonly
                                                        :rules="[$rules.required]"></v-text-field>
                                                </v-col>
                                                <v-col cols="4" v-if="!esAsistencias">
                                                    <v-text-field label="No. Exterior" v-model="poliza.num_exterior"
                                                        readonly :rules="[$rules.required]"></v-text-field>
                                                </v-col>
                                                <v-col cols="4" v-if="!esAsistencias">
                                                    <v-text-field label="No. Interior" v-model="poliza.num_interior"
                                                        readonly :rules="[$rules.required]"></v-text-field>
                                                </v-col>
                                                <v-col cols="4" v-if="!esAsistencias">
                                                    <v-text-field label="Colonia" v-model="poliza.colonia" readonly
                                                        :rules="[$rules.required]"></v-text-field>
                                                </v-col>

                                                <v-col cols="4" v-if="!esAsistencias">
                                                    <v-text-field label="Código Postal" v-model="poliza.codigoPostal"
                                                        v-mask="'#####'" readonly
                                                        :rules="[$rules.required]"></v-text-field>
                                                </v-col>

                                                <v-col cols="4" v-if="poliza.regimen != null && !esAsistencias">
                                                    <v-select label="Estado de la República"
                                                        v-model="poliza.estadoRepublicaSelected" readonly
                                                        :items="ESTADOS_MEXICO" item-text="estadoRepublica"
                                                        item-value="id" :rules="[$rules.required]">
                                                    </v-select>
                                                </v-col>
                                                <v-col cols="4" v-if="!esAsistencias">
                                                    <v-text-field label="Municipio" v-model="poliza.municipio" readonly
                                                        :rules="[$rules.required]"></v-text-field>
                                                </v-col>
                                                <v-col cols="4" v-if="productoAseguradora == 'Hogar'">
                                                    <v-text-field label="Año en que se construyo"
                                                        v-model="poliza.años_construccion" type="number" readonly
                                                        :rules="[$rules.required]"></v-text-field>
                                                </v-col>
                                                <v-col cols="4" v-if="productoAseguradora == 'Hogar'">
                                                    <v-select label="Tipo de construcción" readonly :items="['Maciza']"
                                                        v-model="poliza.tipo_construccion" :rules="[$rules.required]">
                                                    </v-select>
                                                </v-col>
                                                <v-col cols="4" v-if="productoAseguradora == 'Hogar'">
                                                    <v-text-field label="No. de Pisos" v-model="poliza.num_pisos"
                                                        type="number" readonly
                                                        :rules="[$rules.required]"></v-text-field>
                                                </v-col>
                                                <v-col cols="4" v-if="productoAseguradora == 'Hogar'">
                                                    <v-text-field label="Piso en el que vive" v-model="poliza.piso_vive"
                                                        type="number" readonly
                                                        :rules="[$rules.required]"></v-text-field>
                                                </v-col>
                                                <v-col cols="8" style="padding-bottom:5%" v-if="!esAsistencias">
                                                    <v-textarea label="Dirección" :rules="[$rules.required]"
                                                        v-model="poliza.direccion" rows="1" auto-grow readonly>
                                                    </v-textarea>
                                                </v-col>
                                                <v-col cols="6" v-if="esCelular">
                                                    <v-text-field label="Marca y Modelo Celular"
                                                        :value="emision.modeloMarcaCelular" readonly
                                                        :rules="[$rules.required]"></v-text-field>
                                                </v-col>
                                                <v-col cols="6" v-if="esCelular">
                                                    <v-text-field label="Precio Factura Celular"
                                                        :value="emision.precioFacturaCelular || 0" readonly
                                                        :rules="[$rules.required]"></v-text-field>
                                                </v-col>
                                            </v-row>
                                        </v-stepper-content>
                                        <v-stepper-content step="3">
                                            <template>
                                                <v-simple-table fixed-header>
                                                    <template v-slot:default>
                                                        <thead>
                                                            <tr>
                                                                <th class="text-center">
                                                                    Tipo de endoso
                                                                </th>
                                                                <th class="text-center">
                                                                    Fecha
                                                                </th>
                                                                <th class="text-center">
                                                                    Detalle de endoso
                                                                </th>
                                                                <th class="text-center">
                                                                    Usuario
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr v-for="(item, index) in jsonEndosoInfo" :key="index">
                                                                <td class="text-center">
                                                                    {{ item.tipoEndoso }}
                                                                </td>
                                                                <td class="text-center">
                                                                    {{ item.fechaEndoso }}
                                                                </td>
                                                                <td class="text-center">
                                                                    {{ item.detalleEndoso }}
                                                                </td>
                                                                <td class="text-center">{{ item.usuario }}</td>
                                                            </tr>
                                                        </tbody>
                                                    </template>
                                                </v-simple-table>
                                            </template>
                                        </v-stepper-content>
                                    </v-stepper-items>
                                </v-stepper>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-col>

                <v-col cols="5">
                    <CuotasCard :cuotas="cuotas" :search="search" :loading="loading"
                        :customFilter="filterOnlyCapsText" />
                    <DocumentosCard :documentos="documentos" :loading="loading" :customFilter="filterOnlyCapsText"
                        :polizaId="poliza.id" />
                    <EmailsCard :polizaId="poliza.id" :correos="correos" :loading="loading"
                        :customFilter="filterOnlyCapsText" :correoAgente="correoAgente" />

                    <Beneficiarios v-if="load && !esCelular" :emisionId="emision.id" :emisionStatus="poliza.status"
                        :beneficiarios="beneficiarios" :porcentaje="porcentaje" :rfcPoliza="poliza ? poliza.rfc : ''" />
                    <SolicitudesEmision v-if="load" :emisionId="emision.id" :emision="emision" />
                </v-col>
            </v-row>

            <!-- Error dialog -->
            <v-dialog v-model="errorApiDialog" max-width="500">
                <v-card class="border-red">
                    <v-card-title class="dialog-title text-red ">
                        ERROR API
                    </v-card-title>

                    <v-card-text class="text-body-1 mt-2  text-center ">
                        <div class="mb-2 text-black ">
                            Se ha presentando un error al momento de emitir por parte de la aseguradora.
                        </div>
                        <div class="text-black">
                            Reportar al equipo de soporte mandando el link de esta emisión.
                        </div>
                    </v-card-text>

                    <v-card-actions class="justify-end pa-4">

                        <v-btn style="background-color: #ff0042; color: white;" @click="errorApiDialog = false">
                            Cerrar
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>
        <div v-else>
            <v-alert prominent type="error">
                <v-row align="center">
                    <v-col class="grow">
                        Ups parece que esta Venta no te corresponde" Por favor valida con tu
                        supervisor.
                    </v-col>
                    <v-col class="shrink">
                        <v-btn @click="$router.go(-1)" elevation="2" style="background-color: white; color: black;">
                            FINALIZAR
                        </v-btn>
                    </v-col>
                </v-row>
            </v-alert>
        </div>
    </div>
</template>

<script>
import moment from "moment";
import { getLeadBradescardById } from "@/services/leadService";
import { mapActions, mapState } from 'vuex'
import { ESTADOS_MEXICO, getStatusEmisionNombre, getFormaPagoNombre, getEstadoNombre } from "@/constants";
import { getEmisionById, obtenerCertificado, reenviarCertificado, aplicarEndoso, regenerarCuotas, cancelarEmision, reactivarPoliza } from "@/services/emision.service";
import { getCuotasByEmisionId } from "@/services/cuotaService";
import { getCotizacionById } from "@/services/cotizacionService";
import { getMotivosCancelacion } from "@/services/motivosCancelacionService";
import { getProductoById } from "../../../components/productos/productosService";
import CuotasCard from "./components/cards/CuotasCard.vue";
import EmailsCard from "./components/cards/EmailsCard.vue";
import { emitirPolizaSinCodigo } from "@/services/emision.service";
import Beneficiarios from "./components/Beneficiarios.vue";
import SolicitudesEmision from "./components/SolicitudesEmision.vue";
import agregarTelefonoButton from "../../../components/telefonoContacto/agregarTelefonoButton.vue";
import DocumentosCard from "./components/cards/DocumentosCard.vue";
import AccionesEmision from "@/views/pages/emision/components/cards/AccionesEmision.vue";

export default {
    components: {
        DocumentosCard,
        AccionesEmision,
        EmailsCard,
        Beneficiarios,
        SolicitudesEmision,
        CuotasCard,
        agregarTelefonoButton
    },
    computed: {
        ...mapState('polizas', ['porcentaje', 'beneficiarios']),
        esRenovada() {
            return this.emision?.renovacion && this.emision?.renovacion != 0;
        },
        esAsistencias() {
            return this.emision?.asistencias == true;
        },
        nombreProducto() {
            if (!this.currentProducto) return "Cargando...";
            return `${this.currentProducto.nombre} - ${this.currentProducto.producto_lead}`;
        },
        canEdit() {
            var canView = false;
            var roles = [];
            var isAgent = false;

            this.roles.forEach((element) => {
                roles.push(element.rol);
            });
            const rolesToView = [
                "ADMIN",
                "MESADECONTROL",
                "OPERACIONES",
                "OPERADOR",
                "ADMINCC",
                "MANAGERCC",
                "AGENTCC",
                "COORDINADOR",
                "OPERADORSERVICIOS",
                "SUPERVISOR",
                "GERENTE",
                "ADMINCUENTA",
                "AGENTCCELITE"
            ];
            roles.forEach((element) => {
                if (rolesToView.includes(element)) {
                    canView = true;
                }
            });
            roles.forEach((element) => {
                if ("AGENTCC" == element || "AGENTCCELITE" == element) {
                    isAgent = true;
                }
            });
            if (this.poliza.status != "Nueva" && isAgent) {
                canView = false;
            }

            return canView;
        },

        esCelular() {
            if (!this.poliza || !this.poliza.productos) return false;
            const productoFound = this.currentProducto
            return !!productoFound && productoFound.nombre.includes("Seguro Celular");
        },
        tipoContratanteVisible() {
            return this.productoAseguradora === "Hogar";
        },
        isPagadaTotalOrRenovada() {
            return (
                this.poliza.status === "Pagada Total" ||
                this.poliza.status === "Renovada"
            );
        },
        showResponse() {
            const result = this.hasError;
            return result;
        },
        hasError() {
            if (!this.emision || !this.emision.response) return false;

            const code = this.emision.response.code;
            return code !== undefined && code !== null && code !== 200;
        },
        isAdmin() {
            return this.roles.some(role => ["ADMIN"].includes(role.rol));
        },

    },

    data() {
        return {
            ESTADOS_MEXICO,
            requestJson: null,
            loadingEmision: false,
            motivosCancelacion: [],
            tipos_cliente: [
                { text: "Titular", value: "titular" },
                { text: "Asegurado", value: "asegurado" },
            ],
            visible: false,
            loading: false,
            load: false,
            search: "",
            roles: JSON.parse(localStorage.getItem("roles")),
            errorApiDialog: false,
            infoLead: null,
            poliza: {
                poliza: null,
                id: null,
                status: null,
                type: null,
                productos: null,
                ejecutivoOperacion: null,
                cliente: null,
                newCliente: null,
                agente: null,
                newAgente: null,
                landing: null,
                leadId: null,
                anterior: null,
                emitidaCheck: null,
                emitidDate: null,
                primerPagoCheck: null,
                primerPagoDate: null,
                canceladaCheck: null,
                canceladaDate: null,
                canceladaMotivo: null,
                finalizadaCheck: null,
                finalizadaDate: null,
                emisionDate: null,
                finalizadaMotivo: null,
                inicioDate: null,
                finDate: null,
                periodicidad: null,
                periodicidadNumber: null,
                primaNeta: null,
                primaTotal: null,
                montoPrimerPago: null,
                montoSubsecuente: null,
                formaPago: null,
                numeroCuotas: null,
                primerPagoPolizaDate: null,
                noCuotasPagadas: null,
                creadoPorDate: null,
                creadoPor: null,
                ultimaModoficacionDate: null,
                ultimaModoficacion: null,
                observaciones: null,
                nombres: null,
                apellidoPaterno: null,
                apellidoMaterno: null,
                fechaNacimiento: null,
                selectedGenero: null,
                celular: null,
                correoElectronico: null,
                estadoRepublicaSelected: null,
                codigoPostal: null,
                modelo: null,
                marca: null,
                submarca: null,
                version: null,
                detalleAuto: null,
                plan: null,
                razonSocial: null,
                regimen: null,
                origenAuto: null,
                usoAuto: null,
                noMotor: null,
                noSerie: null,
                placas: null,
                notas: null,
                canceladaFinalizadaMotivo: null,
                rfc: null,
                tipo_cliente: null,
                tipo_contratante: null,
                lead_id: null,
                años_construccion: null,
                tipo_construccion: null,
                num_pisos: null,
                piso_vive: null,
                reactivadaDate: null,
                renovadaDate: null,
                renovadaNum: null,
                mesMembresia: null,
                reactivacion: null,
                polizaAseguradora: null
            },
            correoAgente: null,
            years: null,
            productos: [],
            cuotas: [],
            nombreCliente: "",
            documentos: [],
            correos: [],
            tipos_contratante: [
                { text: "Propietario", value: "propietario" },
                { text: "Inquilino", value: "inquilino" },
            ],
            emision: null,
            uuid: this.$route.params.uuid,
            currentProducto: null,
            productoAseguradora: null,
            leadSinAsignar: true,
            jsonEndosoInfo: null,
            hasEndoso: false,
            comercialAsignado: "",
            facturacionItems: [
                {
                    text: "Sí",
                    value: true,
                },
                {
                    text: "No",
                    value: false,
                },
            ],
            tipoRegimenItems: [
                "Sueldos y Salarios e Ingresos Asimilados a Salarios",
                "Arrendamiento",
                "Régimen de Enajenación o Adquisición de Bienes",
                "Demás ingresos",
                "Residentes en el Extranjero sin Establecimiento Permanente en México",
                "Ingresos por Dividendos (socios y accionistas)",
                "Personas Físicas con Actividades Empresariales y Profesionales",
                "Ingresos por intereses",
                "Régimen de los ingresos por obtención de premios",
                "Sin obligaciones fiscales",
                "Incorporación Fiscal",
                "Régimen de las Actividades Empresariales con ingresos a través de Plataformas Tecnológicas",
                "Régimen Simplificado de Confía",
                "",
            ],
            conceptoCFDIItems: [
                "Gastos en general",
                "Primas por seguros de gastos médicos",
                "Sin efectos fiscales",
            ],
            motivosCancelacionFiltrados: [],
        };
    },
    methods: {
        filterOnlyCapsText(value, search) {
            return (
                value != null &&
                search != null &&
                typeof value === "string" &&
                value
                    .toString()
                    .toLocaleUpperCase()
                    .indexOf(search) !== -1
            );
        },
        goBack() {
            if (this.infoLead?.uuid) {
                return this.$router.push(`/bradescard/leads-bradescard/lead/${this.infoLead.uuid}`);
            } else if(window.history.length > 1) {
                return this.$router.go(-1);

            } else{
                return this.$router.push('/');
            }
        },
        reloadPage() {
            return this.$router.go(0);
        },

        ...mapActions("polizas", ['getBeneficiarios']),

        verEmisionEditable() {
            this.$router.push(`/actualizar-emision/${this.uuid}`);
        },
        async obtenerProducto(id) {
            const response = await getProductoById(id);
            this.currentProducto = response.data.producto;

        },
        async handleEmitirSinCodigo() {
            this.loadingEmision = true;
            try {
                await emitirPolizaSinCodigo({ emisionId: this.poliza.id });
                this.showSuccessToast("Se ha emitido la póliza correctamente", () => this.reloadPage())
            } catch (error) {
                this.showErrorToast("Se ha producido un error al emitir la póliza: " + error.message)
            } finally {
                this.loadingEmision = false;
            }
        },
        async handleObtenerCertificado() {
            try {
                await obtenerCertificado(this.poliza.id);
                this.showSuccessToast("Certificado obtenido correctamente", () => this.reloadPage())
            } catch (e) {
                this.showErrorToast("Se ha producido un error al obtener el certificado: " + e.message)
            }
        },
        async handleReenviarCertificado() {
            try {
                await reenviarCertificado(this.poliza.globalInteractionId);
                this.showSuccessToast("Se ha reenviado el certificado correctamente", () => this.reloadPage())
            } catch (e) {
                this.showErrorToast("Se ha producido un error al reenviar el certificado: " + e.message)
            }
        },
        async handleAplicarEndoso(body) {
            try {
                await aplicarEndoso(this.poliza.id, body);
                this.showSuccessToast("Endoso aplicado correctamente", () => this.reloadPage())
            } catch (e) {
                this.showErrorToast("Se ha producido un error al aplicar el endosado: " + e.message)
            }
        },

        handleCotizarWs() {
            let route = "";
            if (
                this.currentProducto.etiqueta_aseguradora == 1 ||
                this.currentProducto.etiqueta_aseguradora == 2 ||
                this.currentProducto.etiqueta_aseguradora == 3
            ) {
                route = "v1/bradescard/cotiza/landing";
            } else if (this.currentProducto.etiqueta_aseguradora == 5) {
                route = "v1/aurrera/cotiza/landing";
            }
            this.showInfoToast("Estamos cotizando con la aseguradora espera un poco! ")
            const config = {
                headers: {
                    Authorization: "Bearer " + localStorage.agenteAccessToken,
                },
            };
            let jsonResponse = this.emision;
            let numeroInteriorSingle =
                jsonResponse.num_interior?.replace(/[a-zA-Z]/g, "") || "1";

            let numeroExteriorSingle =
                jsonResponse.num_exterior?.replace(/[a-zA-Z]/g, "") || "1";

            jsonResponse.num_exterior = numeroExteriorSingle;
            jsonResponse.id = this.emision.id;
            jsonResponse.num_interior = numeroInteriorSingle;
            jsonResponse.codigoPostal = jsonResponse.codigo_postal;


            this.$axios.post(route, jsonResponse, config).then((response) => {
                if (response.data.status == "FAILED") {
                    this.showErrorToast("Ocurrio un error al cotizar: " + response.data.message);
                } else {
                    this.showSuccessToast("Certificado obtenido correctamente", () => this.reloadPage())
                }
            });
        },
        async handleRegenerarCuotas() {
            try {
                const response = await regenerarCuotas(this.poliza.id);
                console.log(response)
                this.showSuccessToast("Se han regenerado las cuotas correctamente", () => this.reloadPage())
            } catch (e) {
                this.showErrorToast("Se ha producido un error al generar las cuotas: " + e.message)
                console.log(e)
            }

        },

        handleRenovacionManual() {
            this.loading = true;
            const config = {
                headers: {
                    Authorization: "Bearer " + localStorage.agenteAccessToken,
                },
            };
            this.$axios
                .get(`/v1/emision/renovar/${this.emision.id}`, config)
                .then((response) => {
                    const nuevaEmision = response.data;
                    this.$router.push(`/emision/${nuevaEmision.id}`);
                })
                .catch((error) => {
                    this.$toast.error("Hubo un error al intentar renovar la póliza.");
                    console.error("Error en renovación manual:", error);
                })
                .finally(() => {
                    this.loading = false;
                    this.showRenovationModal = false;
                });
        },
        async handleReactivarPoliza() {
            try {
                const response = await reactivarPoliza(this.emision.id);
                console.log(response)
                this.showSuccessToast("Se ha reactivado la emisión correctamente", () => this.reloadPage())
            } catch (e) {
                this.showErrorToast("Se ha producido un error al reactivar la emisión: " + e.message)
                console.log(e)
            }

        },
        async handleCancelarEmision(body) {
            try {
                const response = await cancelarEmision(this.emision.id, body);
                console.log(response)
                this.showSuccessToast("Se ha cancelado la emisión", () => this.reloadPage())
            } catch (e) {
                this.showErrorToast("Se ha producido un error al cancelar la emisión: " + e.message)
                console.log(e)
            }
        },


        async cargarEmision() {
            const uuid = this.$route.params.uuid;
            if (!uuid) {
                console.error("UUID no definido");
                return;
            }
            const emisionResponse = await getEmisionById(uuid);
            if (!emisionResponse) {
                this.leadSinAsignar = false;
            }
            this.emision = { ...JSON.parse(emisionResponse.requestJson), ...emisionResponse };
            this.requestJson = emisionResponse.requestJson
                ? JSON.parse(emisionResponse.requestJson)
                : {};

            if (typeof emisionResponse.endosoJson != "undefined") {
                this.jsonEndosoInfo = JSON.parse(emisionResponse.endosoJson);
                if (this.jsonEndosoInfo.length > 0) {
                    this.hasEndoso = true;
                }
            }

            if (this.emision.response === typeof "object") {
                this.emision.response = JSON.parse(this.emision.response);
                this.$nextTick(() => this.checkApiError());
            }

            this.load = true;
            if (this.emision.aseguradoraId == 3) {
                const cotizacionResponse = await getCotizacionById(this.emision.cotizacionId);
                this.cotizacion = cotizacionResponse.cotizacion;
            }

            //Obtener documentos
            emisionResponse.documentos ? emisionResponse.documentos.map((element) => {
                this.documentos.push({
                    nombre: element.nombre ? element.nombre : "No Disponible",
                    fecha: element.fecha
                        ? moment
                            .utc(element.fecha)
                            .subtract(6, "hours")
                            .format("DD/MM/YYYY HH:mm")
                        : "No Disponible",
                    tipo: element.tipo ? element.tipo : "No Disponible",
                    tipoDocumento: element.tipoDocumento
                        ? element.tipoDocumento
                        : "No Disponible",
                    descripcion: element.nota ? element.nota : "No Disponible",
                    creadoPor: element.creadoPor
                        ? element.creadoPor
                        : "No Disponible",
                    url: element.url,
                });
            })
                : "";

            // Obtener emails
            emisionResponse.correos
                ? emisionResponse.correos.map((element) => {
                    this.correos.push({
                        asunto: element.subject,
                        fecha: element.fecha
                            ? moment
                                .utc(element.fecha)
                                .subtract(6, "hours")
                                .format("DD/MM/YYYY HH:mm")
                            : null,
                        cuerpo: element.cuerpo,
                        remitente: element.remitente,
                    });
                })
                : "";
            this.nombreCliente =
                this.emision.nombre +
                " " +
                this.emision.apellidoPaterno +
                " " +
                this.emision.apellidoMaterno;
            this.poliza.poliza = this.emision.poliza
                ? this.emision.poliza
                : this.emision.id;
            this.poliza.id = this.emision.id;
            this.poliza.reactivacion = this.emision.reactivacion ? "Sí" : "No";
            this.poliza.asistencias = this.emision.asistencias;
            this.poliza.status = getStatusEmisionNombre(this.emision.status)

            this.poliza.type = this.emision.tipoPoliza;
            this.poliza.ejecutivoOperacion = parseInt(this.emision.operadorId);
            this.poliza.agente = this.emision.agenteId;
            this.correoAgente = this.emision.correoAgente
                ? this.emision.correoAgente
                : null;
            this.poliza.landing = this.emision.campania;
            this.poliza.leadId = null;
            this.poliza.anterior = this.emision.polizaAnterior;
            this.poliza.emitidaCheck = null;
            this.poliza.polizaSustituida = emisionResponse.polizaSustituida;
            this.poliza.emitidDate = null;
            this.poliza.primerPagoCheck = null;
            this.poliza.primerPagoDate = null;
            this.poliza.canceladaCheck = null;
            this.poliza.emisionDate = this.emision.fechaEmision
                ? moment(this.emision.fechaEmision, "YYYY-MM-DD").format("DD/MM/YYYY")
                : null;
            this.poliza.canceladaDate = this.emision.fechaCancelacion
                ? moment(this.emision.fechaCancelacion, "YYYY-MM-DD").format(
                    "DD/MM/YYYY"
                )
                : null;
            this.poliza.canceladaMotivo = null;
            this.poliza.finalizadaCheck = null;
            this.poliza.finalizadaDate = this.emision.fechaFinalizacion
                ? moment(this.emision.fechaFinalizacion, "YYYY-MM-DD").format(
                    "DD/MM/YYYY"
                )
                : null;
            this.poliza.finalizadaMotivo = null;
            this.poliza.inicioDate = this.emision.inicio
                ? moment(this.emision.inicio, "YYYY-MM-DD").format("DD/MM/YYYY")
                : null;
            this.poliza.fechaPrimerPago = this.emision.fechaPrimerPago
                ? moment(this.emision.fechaPrimerPago, "YYYY-MM-DD").format(
                    "DD/MM/YYYY"
                )
                : null;
            this.poliza.finDate = this.emision.fin
                ? moment(this.emision.fin, "YYYY-MM-DD").format("DD/MM/YYYY")
                : null;
            this.poliza.periodicidad =
                this.emision.pagoId == 1
                    ? "Anual"
                    : this.emision.pagoId == 2
                        ? "Semestral"
                        : this.emision.pagoId == 3
                            ? "Trimestral"
                            : "Mensual";
            this.poliza.periodicidadNumber = this.emision.pagoId;
            this.poliza.reactivadaDate = this.emision.fechaReactivacion
                ? moment(this.emision.fechaReactivacion, "YYYY-MM-DD").format("DD/MM/YYYY")
                : null;
            this.poliza.renovadaDate = this.emision.inicio
                ? moment(this.emision.inicio, "YYYY-MM-DD").subtract(1, "days").format("DD/MM/YYYY")
                : null;
            this.poliza.renovadaNum = this.emision.renovacion;
            this.years = this.emision.anios ? this.emision.anios : 1;
            this.poliza.primaNeta = this.emision.primaNeta;
            this.poliza.primaTotal = this.emision.total;
            this.poliza.montoPrimerPago = this.emision.primerPago;
            this.poliza.montoSubsecuente = this.emision.subsecuentePago;
            this.poliza.formaPago = getFormaPagoNombre(this.emision.formaPago)
            this.poliza.primerPagoPolizaDate = null;
            this.poliza.noCuotasPagadas = null;
            this.poliza.creadoPorDate = moment
                .utc(this.emision.fecha)
                .subtract(6, "hours")
                .format("DD/MM/YYYY HH:mm");
            this.poliza.creadoPor = this.emision.creadoPor
                ? this.emision.creadoPor
                : "";
            this.poliza.cliente = this.emision.cliente;
            this.poliza.ultimaModoficacionDate = moment
                .utc(this.emision.ultimaModificacion)
                .subtract(6, "hours")
                .format("DD/MM/YYYY HH:mm");
            this.poliza.ultimaModoficacion = this.emision.modificadoPor
                ? this.emision.modificadoPor
                : "No Disponible";
            this.poliza.observaciones = this.emision.observaciones;
            this.poliza.nombres = this.emision.nombre;
            this.poliza.apellidoPaterno = this.emision.apellido_paterno;
            this.poliza.apellidoMaterno = this.emision.apellido_materno;
            this.poliza.selectedGenero = this.emision.genero;
            this.poliza.correoElectronico =
                this.emision.status != 0
                    ? `${this.emision.correoContacto.slice(0, 3)}${"*".repeat(
                        this.emision.correoContacto.split("@")[0].length - 3
                    )}@${this.emision.correoContacto.split("@")[1]}`
                    : this.emision.correoContacto;
            this.poliza.estadoRepublicaSelected = getEstadoNombre(this.emision.estadoId),
                (this.poliza.codigoPostal = this.emision.codigoPostal);
            this.poliza.modelo = this.emision.modelo;
            this.poliza.marca = this.emision.marca;
            this.poliza.certificadoBradescard = this.emision.certificadoBradescard;
            this.poliza.submarca = this.emision.submarca;
            this.poliza.version = this.emision.nombreVehiculo;
            this.poliza.detalleAuto = this.emision.detalleAuto;
            this.poliza.plan =
                this.emision.planId == 1
                    ? "Amplia"
                    : this.emision.planId == 14
                        ? "Amplia Plus"
                        : this.emision.planId == 3
                            ? "Limitada"
                            : "RC_reglamentaria";
            this.poliza.razonSocial = this.emision.razonSocial
                ? this.emision.razonSocial
                : null;
            this.poliza.origenAuto = this.emision.origenAuto;
            this.poliza.usoAuto = this.emision.usoAuto;
            this.poliza.noMotor = this.emision.numMotor;
            this.poliza.noSerie = this.emision.numSerie;
            this.poliza.placas = this.emision.placas;
            this.poliza.notas = this.emision.notas;
            this.poliza.rfc = this.emision.rfc;
            this.poliza.canceladaFinalizadaMotivo = this.emision.motivoCancelacion;
            this.poliza.productos = this.emision.productoId;
            this.poliza.newCliente =
                this.emision.nombre +
                " " +
                this.emision.apellidoPaterno +
                " " +
                this.emision.apellidoMaterno;
            this.poliza.estadoRepublicaSelected = this.emision.estadoId;
            this.poliza.mesMembresia = this.emision.numeroMes;
            let jsonFormat = JSON.parse(this.emision.requestJson);
            this.poliza.statusCivil = jsonFormat.estado_civil;
            this.poliza.calle = jsonFormat.calle;
            this.poliza.num_exterior = jsonFormat.num_exterior;
            this.poliza.num_interior = jsonFormat.num_interior;
            this.poliza.colonia = jsonFormat.colonia;
            this.poliza.municipio = jsonFormat.municipio;
            this.poliza.id = this.emision.id;
            this.poliza.uuid = this.emision.uuid;
            this.poliza.checkgetCertificado = jsonFormat.checkgetCertificado;
            this.poliza.regimen = jsonFormat.tipo_persona;
            this.poliza.genero = jsonFormat.genero;
            this.poliza.direccion = jsonFormat.direccion;
            this.poliza.fechaNacimiento = jsonFormat.fecha_nacimiento
                ? moment(jsonFormat.fecha_nacimiento, "YYYY-MM-DD").format(
                    "DD/MM/YYYY"
                )
                : null;
            this.poliza.celular =
                this.emision.status != 0
                    ? `******${this.emision.telefonoContacto.slice(6, 10)}`
                    : this.emision.telefonoContacto;
            this.poliza.tipo_cliente = jsonFormat.tipo_cliente
                ? jsonFormat.tipo_cliente.toLowerCase()
                : "";
            (this.poliza.tipo_contratante = jsonFormat.tipo_contratante
                ? jsonFormat.tipo_contratante
                : null),
                (this.poliza.años_construccion = jsonFormat.años_construccion
                    ? jsonFormat.años_construccion
                    : null);
            this.poliza.tipo_construccion = jsonFormat.tipo_construccion
                ? jsonFormat.tipo_construccion
                : null;
            this.poliza.num_pisos = jsonFormat.num_pisos
                ? jsonFormat.num_pisos
                : null;
            this.poliza.piso_vive = jsonFormat.piso_vive
                ? jsonFormat.piso_vive
                : null;
            this.comercialAsignado = this.emision.comercialAsignado
                ? this.emision.comercialAsignado
                : null;
            this.poliza.facturar = jsonFormat.facturar || false;
            this.poliza["regimen-fiscal"] = jsonFormat["regimen-fiscal"] || null;
            this.poliza.cfdi = jsonFormat.cfdi || null;

            if (
                this.poliza.tipo_contratante != null &&
                this.poliza.años_construccion != null &&
                this.poliza.tipo_construccion != null &&
                this.poliza.num_pisos != null &&
                this.poliza.piso_vive != null
            ) {
                this.productoAseguradora = "Hogar";
            }
            this.poliza.globalInteractionId = this.emision.globalInteractionId
                ? this.emision.globalInteractionId
                : "";

            this.poliza.polizaAseguradora = this.emision.polizaAseguradora
                ? this.emision.polizaAseguradora
                : "";
            this.poliza.validacionCodigo = this.emision.validacionCodigo

            if (this.poliza.globalInteractionId == "0000") {
                this.actualizarGlobalInteractionId();
            }

            if (typeof this.poliza.cliente != "undefined") {
                this.obtenerCliente(this.poliza.cliente);
            }
            if (typeof this.poliza.agente != "undefined") {
                this.obtenerAgente(this.poliza.agente);
            }
            await this.obtenerProducto(this.poliza.productos);
        },
        async cargarLead() {
            if (this.emision.lead_id == null) return;
            const response = await getLeadBradescardById(this.emision.lead_id);
            this.infoLead = response;


        },
        fetchMotivosCancelacion() {
            const filters = {
                // rol: JSON.parse(localStorage.roles)[0].rol,
                status: 1,
                tipo_producto: this.currentProducto.tipo_producto,
                producto_aseguradora: this.currentProducto.producto_aseguradora || null,
            };
            getMotivosCancelacion(filters).then(({ motivos_cancelacion }) => {
                let motivos = motivos_cancelacion;
                const motivoActual = this.poliza?.canceladaFinalizadaMotivo;

                if (motivoActual && !motivos.find(m => m.motivoCancelacion === motivoActual)) {
                    motivos.push({
                        motivoCancelacion: motivoActual,
                    });
                }

                this.motivosCancelacionFiltrados = motivos;
            });
        },
        checkApiError() {
            if (this.hasError && this.isAdmin) {
                this.errorApiDialog = true;
            }
        },
        async cargarCuotasDePoliza() {
            const response = await getCuotasByEmisionId(this.$route.params.uuid);

            this.cuotas = response.map((element) => ({
                status: element.status,
                valorPagar: `$${element.valorAPagar}`,
                fechaPagoAcordada: element.fechaPagoAcordada
                    ? moment(element.fechaPagoAcordada, "YYYY-MM-DD").format("DD/MM/YYYY")
                    : "No Disponible",
                uuid: element.uuid,
            }));
        },
        obtenerCliente(cliente) {
            const config = {
                headers: {
                    Authorization: "Bearer " + localStorage.agenteAccessToken,
                },
            };
            this.$axios.get(`/v1/cliente/id/${cliente}`, config).then((resp) => {
                this.poliza.newCliente =
                    `${resp.data.nombre}` +
                    " " +
                    `${resp.data.apellidoPaterno}` +
                    " " +
                    `${resp.data.apellidoMaterno}`;
            });
        },
        obtenerAgente(agente) {
            const config = {
                headers: {
                    Authorization: "Bearer " + localStorage.agenteAccessToken,
                },
            };
            this.$axios.get(`/v1/agente/id/${agente}`, config).then((response) => {
                this.poliza.newAgente =
                    `${response.data.nombre}` +
                    " " +
                    `${response.data.apellidoPaterno}` +
                    " " +
                    `${response.data.apellidoMaterno}`;
            });
        },
        toCurrency(number) {
            var formatter = new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
            });
            return formatter.format(number); /* $2,500.00 */
        },
        actualizarGlobalInteractionId() {
            const config = {
                headers: {
                    Authorization: "Bearer " + localStorage.agenteAccessToken,
                },
            };

            let request = {
                id: this.poliza.id,
                inbound: true,
                agente: "707",
            };
            this.actualStatus = request.status;
            this.$axios
                .post("/v1/emision/manual/actualizar", request, config)
                .then(() => {
                });
        },
        showSuccessToast(mensaje, onClose = null) {
            this.$toast.success(
                mensaje,
                {
                    position: "top-right",
                    timeout: 2000,
                    closeOnClick: true,
                    pauseOnFocusLoss: false,
                    pauseOnHover: false,
                    draggable: false,
                    draggablePercent: 0.6,
                    showCloseButtonOnHover: false,
                    closeButton: "button",
                    icon: true,
                    rtl: false,
                    onClose: () => {
                        if (typeof onClose === "function") {
                            onClose();
                        }
                    }
                },
            );
        },
        showErrorToast(mensaje, onClose = null) {
            this.$toast.error(
                mensaje,
                {
                    position: "top-right",
                    timeout: 3000,
                    closeOnClick: true,
                    pauseOnFocusLoss: false,
                    pauseOnHover: false,
                    draggable: false,
                    draggablePercent: 0.6,
                    showCloseButtonOnHover: false,
                    hideProgressBar: true,
                    closeButton: "button",
                    icon: true,
                    rtl: false,
                    onClose: () => {
                        if (typeof onClose === "function") {
                            onClose();
                        }
                    }
                },
            );

        },
        showInfoToast(mensaje, onClose = null) {
            this.$toast.info(
                mensaje,
                {
                    position: "top-right",
                    timeout: 3000,
                    closeOnClick: true,
                    pauseOnFocusLoss: false,
                    pauseOnHover: false,
                    draggable: false,
                    draggablePercent: 0.6,
                    showCloseButtonOnHover: false,
                    hideProgressBar: true,
                    closeButton: "button",
                    icon: true,
                    rtl: false,
                    onClose: () => {
                        if (typeof onClose === "function") {
                            onClose();
                        }
                    }
                },
            );
        },
    },
    watch: {
        "poliza.fechaNacimiento"(newValue) {
            var years = moment(newValue, "DD/MM/YYYY");
            var today = moment().format("DD/MM/YYYY");
            var diference = moment(today, "DD/MM/YYYY").diff(
                moment(years, "DD/MM/YYYY"),
                "years"
            );
            this.poliza.edad = diference;
        },
        years(value) {
            if (value.typeof != "number") {
                this.years = parseInt(value);
                const meses = this.years * 12;
                switch (this.poliza.periodicidadNumber) {
                    case 1:
                        this.poliza.numeroCuotas = meses / 12;
                        break;
                    case 2:
                        this.poliza.numeroCuotas = meses / 6;
                        break;
                    case 3:
                        this.poliza.numeroCuotas = meses / 3;
                        break;
                    case 4:
                        this.poliza.numeroCuotas = meses / 1;
                        break;
                    default:
                        break;
                }
            }
        },
        showResponse: {
            immediate: true,
            handler(newVal) {
                this.errorApiDialog = newVal;
            }
        },

        'emision.response': {
            handler() {
                if (this.showResponse) {
                    this.errorApiDialog = true;
                }
            },
            deep: true
        },
        "$route.path"() {
            location.reload();
        },
        currentProducto: {
            handler() {
                this.fetchMotivosCancelacion();
            },
            deep: true
        },
    },
    async mounted() {
        await this.cargarEmision(),
            await this.cargarLead(),
            await this.cargarCuotasDePoliza();
        await this.fetchMotivosCancelacion();
        await this.getBeneficiarios(this.emision.id);
    },
};
</script>

<style scoped>
.v-stepper__step__step {
    background-color: white;
}

.border-red {
    border: 3px solid red !important;
    border-radius: 4px;
}

.dialog-title {
    justify-content: center;
    display: flex;
}

.justify-center {
    text-justify: auto;
}

.text-red {
    color: red;
}

.text-white {
    color: white;
}

.text-black {
    color: black;
}
</style>
